import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorMounting } from '../../../../@types/model/masterData/pumpingStation/motorMounting';

export default class MasterDataPumpingStationMotorMountingActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_MOUNTINGS', resolve => (pumps : Array<IPumpingStationMotorMounting>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_MOUNTINGS_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}